import { Link } from "react-router-dom";
import { PROFILE } from "@/data/portfolio";
import { useLang } from "@/lib/i18n";


export default function Footer() {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#e5e0d8] py-10 bg-[#faf8f5]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16 flex flex-wrap items-center justify-between gap-4">
        <div className="font-display text-lg text-[#14352a]">
          {PROFILE.name}
        </div>
        <div className="flex flex-wrap items-center gap-6 font-mono-label text-[10px] text-[#86928a]">
          <Link
            to="/analytics"
            data-testid="footer-analytics-link"
            className="text-[#9a7218] link-underline"
          >
            {t("This portfolio is instrumented, see the live data")}
          </Link>
          <span>
            {PROFILE.domain} · {t("Built with care")} · {new Date().getFullYear()}
          </span>
        </div>
      </div>
    </footer>
  );
}
